import { useMemo } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import MobileTailwind from "./MobileTailwind";
import PrimaryButton from "./components/PrimaryButton";
import SubHeader from "./components/SubHeader";

const SplitBillPayment = () => {
  const navigate = useNavigate();
  const { tableNo = "T1" } = useParams<{ tableNo: string }>();
  const [searchParams] = useSearchParams();
  const amountParam = searchParams.get("amount");
  const guestsParam = searchParams.get("guests");

  const splitAmount = useMemo(() => {
    const a = Number(amountParam);
    return a > 0 ? a : 540;
  }, [amountParam]);

  const guestCount = useMemo(() => {
    const g = parseInt(guestsParam ?? "", 10);
    if (!g || g < 1) return 4;
    return Math.min(g, 12);
  }, [guestsParam]);

  const users = Array.from({ length: guestCount }, (_, i) => ({
    label: `User ${i + 1}`,
    amount: splitAmount,
  }));

  return (
    <>
      <MobileTailwind />
      <div id="mobile-root" className="min-h-screen w-full bg-black flex justify-center">
        <div className="relative w-full min-h-screen overflow-x-hidden" style={{ backgroundColor: "#F4F4F5" }}>
          {/* Header */}
          <SubHeader title="Split Bill Payment" />

          {/* Body */}
          <div className="px-4 pt-4 pb-[80px]">
            <div className="bg-white rounded-[6px] border border-[#E6EEFF] px-3">
              {users.map((u, idx) => (
                <div key={u.label} className={`flex flex-col gap-2 py-3 ${idx !== users.length - 1 ? "border-b border-[#E8E9F1]" : ""}`}  >
                  <div className="flex items-baseline justify-between gap-2">
                    <span className="font-opensans font-medium text-[14px] text-[rgba(17,17,17,0.6)]">
                      {u.label}
                    </span>
                    <span className="font-sansation font-bold text-[#111] text-[18px]">
                      ₹{u.amount}
                    </span>
                  </div>

                  <div className="flex gap-2 w-full">
                    <PrimaryButton size="sm" variant="outline" onClick={() => navigate(`/mobile/receipt/${tableNo}?amount=${u.amount.toFixed(2)}`)} >
                      Pay By Cash Later
                    </PrimaryButton>
                    <PrimaryButton size="sm" variant="filled" onClick={() => navigate(`/mobile/receipt/${tableNo}?amount=${u.amount.toFixed(2)}`)}>
                      Pay Now UPI/Card
                    </PrimaryButton>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SplitBillPayment;
